"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEntities_1 = require("./getEntities");
var ENTITY_ID_REGEX = /_\d{1,8}$/;
var ENTITY_INFO_NAME = '_Entity';
var ENTITY_TYPE_PREFIX = '_EType_';
var ENTITY_ID_PREFIX = '_EId_';
var ENTITY_READONLY_PREFIX = '_EReadonly_';
var ENTITY_CSS_REGEX = '^' + ENTITY_INFO_NAME + '$';
var ENTITY_ID_CSS_REGEX = '^' + ENTITY_ID_PREFIX;
var ENTITY_TYPE_CSS_REGEX = '^' + ENTITY_TYPE_PREFIX;
var ENTITY_READONLY_CSS_REGEX = '^' + ENTITY_READONLY_PREFIX;
exports.ALLOWED_CSS_CLASSES = [
    ENTITY_CSS_REGEX,
    ENTITY_ID_CSS_REGEX,
    ENTITY_TYPE_CSS_REGEX,
    ENTITY_READONLY_CSS_REGEX,
];
/**
 * @internal Serialize entity info into a CSS class list string
 * @param editor The editor which contains the entity
 * @param type Type of the entity
 * @param isReadonly Whether the entity is readonly
 * @param originalId (Optional) Existing id of the entity. If this id already exists in the editor, it will be replaced
 * by a new one
 * @param knownIds (Optional) All known entity ids inside this editor. This is a performance optimization when this function
 * will be called multiple times
 */
function serializeEntityInfo(editor, type, isReadonly, originalId, knownIds) {
    if (knownIds === void 0) { knownIds = getAllEntityIds(editor); }
    var id = createEntityId(originalId || type, knownIds);
    return ENTITY_INFO_NAME + " " + ENTITY_TYPE_PREFIX + type + " " + ENTITY_ID_PREFIX + id + " " + ENTITY_READONLY_PREFIX + (isReadonly ? '1' : '0');
}
exports.serializeEntityInfo = serializeEntityInfo;
/**
 * @internal Deserialze entity info string to entity info (type, id, isReadonly)
 * @param entityInfo The entity info string generated from serializeEntityInfo()
 */
function deserialzeEntityInfo(entityInfo) {
    var isEntity = false;
    var type;
    var id = '';
    var isReadonly = false;
    if (entityInfo) {
        entityInfo.split(' ').forEach(function (name) {
            if (name == ENTITY_INFO_NAME) {
                isEntity = true;
            }
            else if (name.indexOf(ENTITY_TYPE_PREFIX) == 0) {
                type = name.substr(ENTITY_TYPE_PREFIX.length);
            }
            else if (name.indexOf(ENTITY_ID_PREFIX) == 0) {
                id = name.substr(ENTITY_ID_PREFIX.length);
            }
            else if (name.indexOf(ENTITY_READONLY_PREFIX) == 0) {
                isReadonly = name.substr(ENTITY_READONLY_PREFIX.length) == '1';
            }
        });
    }
    return isEntity && type
        ? {
            type: type,
            id: id,
            isReadonly: isReadonly,
        }
        : null;
}
exports.deserialzeEntityInfo = deserialzeEntityInfo;
/**
 * @internal Get all known entity ids from an editor
 * @param editor The editor to get entity ids from
 */
function getAllEntityIds(editor) {
    return getEntities_1.default(editor).map(function (e) { return e.id; });
}
exports.getAllEntityIds = getAllEntityIds;
/**
 * @internal Get a selector string for specified entity type and id
 * @param type (Optional) Type of entity
 * @param id (Optional) Id of entity
 */
function getEntitySelector(type, id) {
    var typeSelector = type ? "." + ENTITY_TYPE_PREFIX + type : '';
    var idSelector = id ? "." + ENTITY_ID_PREFIX + id : '';
    return '.' + ENTITY_INFO_NAME + typeSelector + idSelector;
}
exports.getEntitySelector = getEntitySelector;
function createEntityId(existingIdOrType, knownIds) {
    var match = ENTITY_ID_REGEX.exec(existingIdOrType);
    var baseId = match
        ? existingIdOrType.substr(0, existingIdOrType.length - match[0].length)
        : existingIdOrType;
    var newId = '';
    for (var num = (match && parseInt(match[1])) || 0;; num++) {
        newId = baseId + "_" + num;
        if (knownIds.indexOf(newId) < 0) {
            knownIds.push(newId);
            break;
        }
    }
    return newId;
}
//# sourceMappingURL=EntityInfo.js.map